module.exports = __webpack_public_path__ + "img/375w.0818354.jpg";